import languages from "../../translation/config/languages";

export default languages;
